// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {filter, isEmpty} from 'lodash';

// Components
import TableWithSort from '../core/table-with-sort';
import Checkbox from '../core/checkbox';

// Containers
import FormData from '../../containers/form-data';

// Sytles
import './bulk-mapping-table.scss';

const formName = 'bulkMapping';

function BulkMappingTable({bulkMappingType, massActionTargets}) {
    const getShowsColumnConfig = () => [
        {
            dataKey: 'episodeName',
            title: 'Episode Name',
            width: '20%',
        },
        {
            dataKey: 'description',
            title: 'Description',
            width: '30%',
        },
        {
            dataKey: 'genres.0.name',
            title: 'Genres',
            width: '10%',
        },
        {
            dataKey: 'rating',
            title: 'Rating',
            width: '10%',
        },
        {
            dataKey: 'seasonNumber',
            title: 'Season',
            tooltip: 'Season Number',
            width: '10%',
        },
        {
            dataKey: 'episodeNumber',
            title: 'Episode',
            tooltip: 'Episode Number',
            width: '10%',
        },
        {
            dataKey: 'guid',
            renderRowCallback: renderCheckbox,
            title: 'Skip',
            tooltip: 'Skip',
            width: '10%',
        },
    ];

    const getSpecialsColumnConfig = () => [
        {
            dataKey: 'title',
            bulkMappingWidth: '28%',
            title: 'Title',
            width: '25%',
        },
        {
            dataKey: 'description',
            title: 'Description',
            bulkMappingWidth: '29%',
            width: '45%',
        },
        {
            dataKey: 'genres.0.name',
            title: 'Genres',
            width: '10%',
        },
        {
            dataKey: 'rating',
            title: 'Rating',
            width: '10%',
        },
        {
            dataKey: 'guid',
            renderRowCallback: renderCheckbox,
            title: 'Skip',
            tooltip: 'Skip',
            width: '10%',
        },
    ];

    const getShowsRowDetails = () => ({
        whitelistKeys: [
            'title',
            'description',
            'genres',
            'rating',
            'seasonNumber',
            'episodeNumber',
            'originalAirDate',
            'releaseYear',
            'duration',
        ],
    });

    const getSpecialsRowDetails = () => ({
        whitelistKeys: ['title', 'description', 'genres', 'rating', 'originalAirDate', 'releaseYear', 'duration'],
    });

    const renderCheckbox = (dataRow, key) => {
        const checkboxProps = {
            className: 'bulk-mapping-table--checkbox',
            lockingServiceKey: 'bulkMapping',
            key,
            name: 'skippedGuids[]',
            value: !isEmpty(dataRow) ? dataRow.guid : undefined,
        };

        // when you change searchKeys, you also need to change the same ones in mapping-middleware.js
        const searchKeys = ['description', 'duration', 'genres', 'rating', 'title'];

        return (
            <Checkbox
                {...checkboxProps}
                disabled={
                    isEmpty(dataRow) || !isEmpty(filter(searchKeys, (key) => !dataRow[key])) || isEmpty(dataRow.genres)
                }
            />
        );
    };

    return (
        <div className="bulk-mapping-table">
            {massActionTargets ? (
                <FormData formName={formName}>
                    {() => (
                        <TableWithSort
                            className="bulk-mapping-table--table"
                            columnConfig={
                                bulkMappingType === 'SHOWS' ? getShowsColumnConfig() : getSpecialsColumnConfig()
                            }
                            localSort={true}
                            rowDetails={bulkMappingType === 'SHOWS' ? getShowsRowDetails() : getSpecialsRowDetails()}
                            searchData={massActionTargets}
                        />
                    )}
                </FormData>
            ) : null}
        </div>
    );
}

BulkMappingTable.propTypes = {
    bulkMappingType: PropTypes.string.isRequired,
    massActionTargets: PropTypes.array,
};

export default BulkMappingTable;
